import Axios from 'axios';
import humps from 'humps';
import { API_CONSULT } from 'Constants/client-modules';
import { CONSULT_API_URL } from 'Constants/apis';

import * as ACTION_TYPES from './types';

export function createReferralMemo(consultId, body) {
  return {
    types: [
      ACTION_TYPES.REFERRAL_MEMO_CREATE_REQUESTED,
      ACTION_TYPES.REFERRAL_MEMO_CREATE_SUCCEED,
      ACTION_TYPES.REFERRAL_MEMO_CREATE_FAILED,
    ],
    promise: client => client.post(`/consults/${consultId}/referral-memos`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getPreviewReferralMemo(body, token) {
  return {
    types: [
      ACTION_TYPES.REFERRAL_MEMO_PREVIEW_REQUESTED,
      ACTION_TYPES.REFERRAL_MEMO_PREVIEW_SUCCEED,
      ACTION_TYPES.REFERRAL_MEMO_PREVIEW_FAILED,
    ],
    promise: () =>
      Axios.post(`${CONSULT_API_URL}/referral-memos/preview`, body, {
        transformRequest: [data => JSON.stringify(humps.decamelizeKeys(data))],
        headers: {
          Authorization: token,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getReferralMemos(conversationId, params, isLoadMore) {
  return {
    types: [
      ACTION_TYPES.REFERRAL_MEMOS_GET_REQUESTED,
      ACTION_TYPES.REFERRAL_MEMOS_GET_SUCCEED,
      ACTION_TYPES.REFERRAL_MEMOS_GET_FAILED,
    ],
    promise: client => client.get(`/conversations/${conversationId}/referral-memos`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      isLoadMore,
    },
  };
}
